import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import auth from "./modules/auth";
import user from "./modules/user";
import money from "./modules/money";
import portfolio from "./modules/portfolio";
import cash from "./modules/cash";
import debits from "./modules/debits";
import portfolios from "./modules/portfolios";
import watchList from "./modules/watchList";
import stock from "./modules/stock";
import instruction from "./modules/instruction";
import income from "./modules/income";
import currenciesRate from "./modules/currenciesRate";
import transactions from "./modules/transactions";
import brokers from "./modules/brokers";
import clientList from "./modules/client_list";
import contact from "./modules/contact";
import report from "./modules/report";
import assetDynamics from "./modules/assetDynamics";
import passwordRecovery from "./modules/passwordRecovery";
import register from "./modules/register";
import pifs from "./modules/pifs";
import documents from "./modules/documents";

// ================================================= new modules
import { User_MODULE } from "./modules/user/index";
import { Request_MODULE } from "./modules/request";
import { Money_MODULE } from "./modules/money_MODULE";
import { CurrencySelect_MODULE } from "./modules/currency-select_MODULE";
import { Portfoilo_MODULE } from "./modules/portfolio_MODULE";

const Store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    User_MODULE,
    Request_MODULE,
    Money_MODULE,
    CurrencySelect_MODULE,
    Portfoilo_MODULE,
    auth,
    user,
    money,
    portfolio,
    cash,
    debits,
    portfolios,
    watchList,
    stock,
    income,
    currenciesRate,
    transactions,
    brokers,
    clientList,
    instruction,
    contact,
    report,
    assetDynamics,
    passwordRecovery,
    register,
    pifs,
    documents
  }
});
export default Store;
